import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
// CONTEXT
import useFieldEngagementContext from '../context/useFieldEngagementContext';

export default function FieldDetailsModal() {
  const { fieldDetailsData, setFieldDetailsData } = useContext(useFieldEngagementContext);
  const columns = [
    {
      field: 'account_code',
      headerName: 'Account Code',
      width: 100,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'account_name',
      headerName: 'Account Name',
      width: 300,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'date_scheduled',
      headerName: 'Date Scheduled',
      width: 100,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => moment(row.date_scheduled).format('YYYY-MM-DD'),
    },
    {
      field: 'date_completed',
      headerName: 'Date Engaged',
      width: 100,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        row.date_completed !== null ? moment(row.date_completed).format('YYYY-MM-DD') : '',
    },
  ];

  const handleClose = () => {
    setFieldDetailsData({ ...fieldDetailsData, toggle: false, details: [] });
  };

  return (
    <Dialog onClose={handleClose} open={fieldDetailsData?.toggle} fullWidth maxWidth='lg'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Field Engagement Details
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            marginBottom: 3,
            height: '800px',
            position: 'relative',
            '& .super-app-theme--header': {
              fontWeight: 'bold',
              backgroundColor: '#6B8D3E',
              color: '#fff',
            },
          }}
        >
          <DataGrid
            rows={fieldDetailsData?.details}
            rowCount={fieldDetailsData?.details.length}
            columns={columns}
            pageSize={50}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
